import i18n from 'i18n-js';

import { OperationSearchItem, RecipeOperationSearchItem } from '@interfaces/search';

export const getLinkedText = (item: OperationSearchItem | RecipeOperationSearchItem): string => {
  if (!item?.linkedNcFiles?.length) {
    return '';
  }

  if (item?.linkedNcFiles?.length > 1) {
    return i18n.t('Already linked to {{amount}} other batches', { amount: item?.linkedNcFiles?.length });
  }

  if (item?.linkedNcFiles?.[0]?.ncFileName) {
    return `${i18n.t('Already linked to')}: ${item?.linkedNcFiles?.[0]?.ncFileName}`;
  }

  return '';
};
